export default "__VITE_ASSET__DVToHbKk__"